import React from 'react';

const INCIDENT_TYPES = [
  { value: 'discipline_investigation', label: 'Discipline / Investigation' },
  { value: 'safety_concern', label: 'Safety Concern' },
  { value: 'supervisor_directive_conflict', label: 'Supervisor Directive Conflict' },
  { value: 'contract_issue', label: 'Contract Issue' },
  { value: 'injury_near_miss', label: 'Injury / Near Miss' },
  { value: 'harassment_conduct', label: 'Harassment / Conduct' },
  { value: 'other', label: 'Other' },
];

function Field({ label, children, hint }) {
  return (
    <div className="ff-field">
      <label className="ff-label">{label}</label>
      {children}
      {hint && <span className="ff-hint">{hint}</span>}
    </div>
  );
}

function BasicInfoForm({ caseData, setCaseData, investigationMode = false }) {
  function update(field, value) {
    setCaseData(prev => ({ ...prev, [field]: value }));
  }

  return (
    <div className="ff-card" data-testid="basic-info-form">
      <h2>Basic Information</h2>
      <p className="ff-card-description">
        Enter the core facts first. These details help AskStewie organize your notes correctly.
      </p>

      <div className="ff-form-grid">
        <Field label="Case Title">
          <input
            type="text"
            className="ff-input"
            value={caseData.title}
            onChange={(e) => update('title', e.target.value)}
            placeholder="Example: Office meeting after lockout concern"
            data-testid="title-input"
          />
        </Field>

        <Field label="Incident Type">
          <select
            className="ff-select"
            value={caseData.incident_type}
            onChange={(e) => update('incident_type', e.target.value)}
            data-testid="incident-type-select"
          >
            {INCIDENT_TYPES.map(type => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </select>
        </Field>

        <Field label={investigationMode ? "Meeting / Incident Date" : "Date"}>
          <input
            type="date"
            className="ff-input"
            value={caseData.date}
            onChange={(e) => update('date', e.target.value)}
            data-testid="date-input"
          />
        </Field>

        <Field label={investigationMode ? "Meeting / Incident Time" : "Time"}>
          <input
            type="time"
            className="ff-input"
            value={caseData.time}
            onChange={(e) => update('time', e.target.value)}
            data-testid="time-input"
          />
        </Field>

        <Field label="Location" hint="Station, yard, office, truck, etc.">
          <input
            type="text"
            className="ff-input"
            value={caseData.location}
            onChange={(e) => update('location', e.target.value)}
            placeholder="Substation, control room, office..."
            data-testid="location-input"
          />
        </Field>

        <Field label="Department">
          <input
            type="text"
            className="ff-input"
            value={caseData.department}
            onChange={(e) => update('department', e.target.value)}
            placeholder="Operations, Maintenance, etc."
            data-testid="department-input"
          />
        </Field>

        <Field label="Crew">
          <input
            type="text"
            className="ff-input"
            value={caseData.crew}
            onChange={(e) => update('crew', e.target.value)}
            placeholder="Crew name or number"
            data-testid="crew-input"
          />
        </Field>

        <Field label="Job / Assignment">
          <input
            type="text"
            className="ff-input"
            value={caseData.assignment}
            onChange={(e) => update('assignment', e.target.value)}
            placeholder="What you were assigned to do"
            data-testid="assignment-input"
          />
        </Field>

        <Field label="Equipment Involved" hint="Breaker, feeder, relay, line, etc.">
          <input
            type="text"
            className="ff-input"
            value={caseData.equipment}
            onChange={(e) => update('equipment', e.target.value)}
            placeholder="Equipment type, number, location"
            data-testid="equipment-input"
          />
        </Field>

        <Field label={investigationMode ? "Who Called or Questioned You?" : "Supervisor Present"}>
          <input
            type="text"
            className="ff-input"
            value={caseData.supervisor}
            onChange={(e) => update('supervisor', e.target.value)}
            placeholder="Name and title"
            data-testid="supervisor-input"
          />
        </Field>
      </div>
    </div>
  );
}

export default BasicInfoForm;
